module.exports = __webpack_public_path__ + "media/images/components/cms/full_width_banner_component/flourish-d4615d54f275b30762af68f32cf4c84f.svg";